import { Controller } from "@hotwired/stimulus"

// Countdown timer controller for Coming Soon page
// Connects to data-controller="countdown-timer"
export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { endDate: String }

  connect() {
    this.updateCountdown()
    this.interval = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    const endTime = new Date(this.endDateValue).getTime()
    const now = new Date().getTime()
    const timeLeft = (endTime - now) / 1000

    if (timeLeft <= 0) {
      this.setDisplay(0, 0, 0, 0)
      clearInterval(this.interval)
      return
    }

    const days = Math.floor(timeLeft / (60 * 60 * 24))
    const hours = Math.floor((timeLeft / (60 * 60)) % 24)
    const minutes = Math.floor((timeLeft / 60) % 60)
    const seconds = Math.floor(timeLeft % 60)

    this.setDisplay(days, hours, minutes, seconds)
  }

  setDisplay(days, hours, minutes, seconds) {
    if (this.hasDaysTarget) {
      this.daysTarget.textContent = this.format(days)
    }
    if (this.hasHoursTarget) {
      this.hoursTarget.textContent = this.format(hours)
    }
    if (this.hasMinutesTarget) {
      this.minutesTarget.textContent = this.format(minutes)
    }
    if (this.hasSecondsTarget) {
      this.secondsTarget.textContent = this.format(seconds)
    }
  }

  format(value) {
    return value < 10 ? `0${value}` : `${value}`
  }
}
